
import { get, post } from '../request'
/**订单管理模块 */
export default {
    /**
    * @description 订单支付类型 所有
    * @returns Object
    */
    getOrderPayWaysAll() {
        return get(`/payWay/selectPayWayList`, {}, true)
    },


    /**
     * @description 订单查询所有
     * @param {String} params 
     * @returns Object
     */
    getOrderSelectAll(params) {
        return get(`/admin/order/selectAll`, params, true, 30000)
    },


    /**
     * @description 订单查询biPlate
     * @param {String} params 
     * @returns Object
     */
    getOrderSelectByPlate(params) {
        return get(`/admin/order/selectByPlate`, params, true)
    },
    /**
     * @description 订单退款轮询（单一）
     * @param {String} params 
     * @returns Object
     */
    getOrderRefundLunxunByNo(params) {
        return get(`/admin/order/orderRefundQuery?refundRequestNo=${params}`)
    },
    /**
     * @description 订单退款轮询 （混合支付）
     * @param {String} params 
     * @returns Object
     */
    hxRefundQueryOrderByNo(params) {
        return get(`/admin/order/hxRefundQuery?outOrderNo=${params}`)
    },



    /**
     * @description 订单退款查询byid
     * @param {String} params 
     * @returns Object
     */
    getOrderRefundSelectById(params) {
        return get(`/admin/order/selectById?id=${params}`)
    },
    /**
    * @description 订单退款byid
    * @param {String} params 
    * @returns Object
    */
    postOrderRefundById(params) {
        return post(`/admin/order/tradeRefund/${params}`)
    },
    /**
   * @description 订单 可退款查询byid
   * @param {String} params 
   * @returns Object
   */
    getOrderRefundAmountById(params) {
        return get(`/admin/order/refundAmount?id=${params}`)
    },
    /**
      * @description 充值订单退款byid
      * @param {String} params 
      * @returns Object
      */
    postOrderCardTradeRefundById(id, refundMoney, giftRefundMoney) {
        // return post(`/admin/order/cardTradeRefund/${params}`)
        return post(`/admin/order/cardTradeRefund/${id}/${refundMoney}/${giftRefundMoney}`)
    },
    /**
     * @description 充值订单退款查询
     * @param {String} params 
     * @returns Object
     */
    getOrderCardTradeRefundQuery(params) {
        return get(`/admin/order/cardTradeRefundQuery?refundRequestNo=${params}`)
    },
    /**
     * @description 充值记录查询按卡ID
     * @param {String} params 
     * @returns Object
     */
    getSelectByCardId(params) {
        return get(`/cardTopUpRecord/selectByCardId/${params}`)
    },
    /**
        * @description 根据订单号打印小票
        * @param {Object} params  {orderNo,type 1加油 2 充值}
        * @returns Object
        */
    printReceipt(params) {
        return get(`/admin/order/orderPayprint`, params)
    },
    /***充值退款现金全款退 */
    cardTopUpRefundAll(param) {
        return get(`/card/cardCashRefund`, param)
    },
    /***查询加油付款记录 */
    $getFuelPayRecordList(params) {
        return get(`/admin/order/selectAllPayRecord`, params, true, 30000)
    },
    /***查询加油付款记录详情状态 */
    $getFuelPayRecordDetail(params) {
        return get(`/admin/order/orderPayStateByNo`, params, true)
    },
    /***加油退款记录 */
    orderRefundRecords(params) {
        return get(`/admin/order/selectAllPayRefundRecord`, params, true, 30000)
    },
    /***加油付款记录根据订单号退款 */
    orderFuelPayRecordRefund(params) {
        return get(`/admin/order/orderPayStateByNoRefund?outOrderNo=${params}`)
    },
    /*** 加油付款记录退款轮询 */
    orderFuelPayRecordRefundLunxun(params) {
        return  //get(`/admin/order/orderPayStateByNoRefundLunxun`, params)
    },
    /**加油付款记录退全款轮询 */
    orderFuelPayRecordRefundAll(params) {
        return //get(`/admin/order/orderPayStateByNoRefundAll`, params)
    },
    /*** 加油订单删除 */
    deleteOrder(params) {
        return get(`/admin/order/delOrderById`, params)
    },
    /*** 批量删除加油订单（ids 用逗号分隔） */
    batchDeleteOrder(params) {
        return get(`/admin/order/delOrderById`, params)
    }

}